import styled, { css } from 'styled-components';

export const BackgroundWrapper = styled.div`
  ${({ theme, backgroundStudio }) => css`
    width: 100%;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 32px 24px;
      border-radius: 16px;
      background: ${backgroundStudio ? 'linear-gradient(180deg, #D7BDE8 0%, #FEE3C8 100%)' : '#ffffff'};
    }
  `}
`;

export const GuideContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9999;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `};
`;

export const HighlightWrapper = styled.div`
  ${({ theme, skeleton, width }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    justify-content: ${skeleton ? 'flex-start' : 'center'};
    align-items: center;
    gap: 40px;
    padding: ${skeleton ? '44px 0 70px 0' : '32px 0'};
    position: relative;
    width: ${`calc(${width || 100}% - ${!width || width === 100 ? '0px' : '8px'})`};
    min-height: 430px;
    border-radius: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      min-height: 196px;
      flex-direction: column;
      gap: 0;
      align-items: center;
      white-space: nowrap;
      overflow-x: auto;
      padding: ${skeleton ? '44px 0 70px 0' : '24px 0'};
    }
  `}
`;

export const DivContents = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    gap: 32px;
    justify-content: center;
    min-height: 343px;
    padding: 0 32px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 16px;
      padding: 0 20px;
      white-space: normal;
    }
  `}
`;

export const DivImg = styled.div`
  ${({ theme, variant }) => {
    const variants = {
      HighLightProduct12: {
        width: '496px',
      },
      HighLightProduct13: {
        width: '496px',
      },
      HighLightProduct14: {
        width: '524px',
      },
    };

    return css`
      width: ${variants[variant] ? variants[variant].width : '50%'};
      max-width: fit-content;
      display: flex;
      justify-content: flex-end;

      img {
        max-width: 100%;
      }

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        width: 100%;
        order: 0;
        justify-content: center;
        padding-top: 24px;
      }
    `;
  }}
`;

export const DivText = styled.div`
  ${({ theme, variant }) => {
    const variants = {
      HighLightProduct2: {
        maxWidth: '550px',
      },
      HighLightProduct3: {
        maxWidth: '461px',
      },
      HighLightProduct4: {
        maxWidth: '521px',
      },
      HighLightProduct12: {
        maxWidth: '510px',
      },
      HighLightProduct13: {
        maxWidth: '510px',
      },
      HighLightProduct14: {
        maxWidth: '510px',
      },
    };

    return css`
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: 24px;
      max-width: ${variants[variant] && variants[variant].maxWidth};

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        gap: 16px;
        width: 100%;
      }
    `;
  }}
`;

export const Title = styled.p`
  ${({ theme, variant }) => {
    const variants = {
      HighLightProduct2: {
        maxWidth: '100%',
      },
      HighLightProduct3: {
        maxWidth: '100%',
      },
      HighLightProduct4: {
        maxWidth: '397px',
      },
      HighLightProduct12: {
        maxWidth: '340px',
        background: `${theme.v2.colors.gradient.secondary}`,
        backgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        fontWeight: `${theme.v2.font.weights.bold}`,
        fontSize: '20px',
      },
      HighLightProduct13: {
        maxWidth: '340px',
        background: `${theme.v2.colors.gradient.secondary}`,
        backgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        fontWeight: `${theme.v2.font.weights.bold}`,
        fontSize: '20px',
      },
      HighLightProduct14: {
        maxWidth: '340px',
        background: `${theme.v2.colors.gradient.primary}`,
        backgroundClip: 'text',
        webkitTextFillColor: 'transparent',
        fontWeight: `${theme.v2.font.weights.bold}`,
        fontSize: '20px',
      },
    };

    return css`
      color: ${theme.v2.colors.brand.primaryExtraDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${variants[variant].fontSize || '32px'};
      font-weight: ${variants[variant].fontWeight || theme.v2.font.weights.medium};
      line-height: 1.5;
      margin: 0px;
      max-width: ${variants[variant] && variants[variant].maxWidth};
      background: ${variants[variant].background};
      background-clip: ${variants[variant].backgroundClip};
      -webkit-text-fill-color: ${variants[variant].webkitTextFillColor};

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        font-size: ${theme.v2.font.sizes.sm2};
      }

      strong {
        font-weight: 500;
      }
    `;
  }}
`;

export const Description = styled.p`
 ${({ theme, variant }) => {
    const variants = {
      HighLightProduct12: {
        fontWeight: `${theme.v2.font.weights.regular}`,
        fontSize: `${theme.v2.font.sizes.xs}`,
        color: `${theme.v2.colors.neutral.lowMedium}`,
      },
      HighLightProduct13: {
        fontWeight: `${theme.v2.font.weights.regular}`,
        fontSize: `${theme.v2.font.sizes.xs}`,
        color: `${theme.v2.colors.neutral.lowMedium}`,
      },
      HighLightProduct14: {
        fontWeight: `${theme.v2.font.weights.regular}`,
        fontSize: `${theme.v2.font.sizes.xs}`,
        color: `${theme.v2.colors.neutral.lowMedium}`,
      },
    };

    return css`
      color: ${(variants[variant] && variants[variant].color) || theme.v2.colors.neutral.lowDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${(variants[variant] && variants[variant].fontSize) || theme.v2.font.sizes.sm};
      font-weight: ${variants[variant] && variants[variant].fontWeight};
      line-height: ${theme.v2.font.lineHeight.text};
      margin: 0;

      strong {
        font-weight: ${theme.v2.font.weights.medium};
      }

      .subtitle {
        color: ${theme.v2.colors.brand.primaryMedium};
        font-size: ${theme.v2.font.sizes.sm2};
        font-weight: ${theme.v2.font.weights.medium};
        line-height: 1.5;
        margin: 0;
      }

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        font-size: ${theme.v2.font.sizes.xxs};
      }
    `;
  }}
`;

export const ButtonWrapper = styled.div`
 ${({ theme }) => css`
  @media (max-width: ${theme.v2.breakpoints.sm}) {
    order: 2;
    width: 100%;
    max-width: 100%;
  }
 `}
`;

export const MenuHighlight = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 8px;
      justify-content: flex-start;
      overflow-x: scroll;
      padding: 12px 20px;
      width: 100%;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const MenuHighlightButton = styled.button`
  ${({ theme, active }) => css`
    padding: 12px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 39.5px;
    background-color: ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.neutral.highPure};
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    cursor: pointer;
    transition: background-color 0.3s;
    outline: none;
    border: none;

    :hover {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 12px;
    }
  `}
`;

export const MenuHighlightIcon = styled.div`
  display: flex;
  padding-right: 8px;
`;

export const MenuHighlightTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Tag = styled.div`
  ${({ theme, tagColor }) => css`
    display: inline-grid;
    padding: 4px 8px;
    border-radius: 10px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.bold};
    background-color: ${tagColor};

    &:after {
      content: '';
      display: block;
      width: 11px;
      height: 9px;
      background-color: ${tagColor};
      border-radius: 50%;
      margin-left: 8px;
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      transform: rotate(180deg);
      position: relative;
      left: -5px;
      bottom: -2px;
      margin-bottom: -28px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const SkeletonWrapper = styled.div`
  ${({ theme, column, alignStart }) => css`
    align-items: ${alignStart ? 'flex-start' : 'center'};
    display: flex;
    flex-direction: ${column ? 'column' : 'row'};
    flex-wrap: wrap;
    gap: ${column ? '44px' : '20px'};
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 20px;

      div {
        max-width: 320px;
      }
    }
  `}
`;

export const WrapperTitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {

    }
  `}
`;

export const GuidePopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 320px;
`;

export const GuidePopoverTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `}
`;

export const GuidePopoverDescription = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
  `}
`;
